module.exports = __webpack_public_path__ + "20250721160708/img/teacherAuth.03169ba7.png";